export const KISS_WEB_CHANNEL = 'WEB41001'

/** 项目名 */
export const PROJECT_NAME = 'My Fiction'
